export default __webpack_public_path__ + "static/media/icon-faq.47dfaa69.svg";